import { Env, analyticsEndpointProd } from '../app/models';
import bapiHosts from '../config/bapi-hosts.json';
import packageJson from '../../package.json';

export const environment = {
    production: true,
    name: Env.qa,
    apiUrl: bapiHosts.qa,
    bapiEnv: 'staging',
    version: packageJson.version,
    analyticsEndpoint: analyticsEndpointProd
};
